import { styled } from '@mui/material/styles'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import { Colors } from '../../theme'

export const Page = styled(Box)(() => ({
  minHeight: '100vh',
  '@supports (min-height: 100dvh)': {
    minHeight: '100dvh',
  },
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: '32px 16px',
  background: `linear-gradient(135deg, ${Colors.BG_START} 0%, ${Colors.BG_END} 100%)`,
}))

export const Column = styled('div')(() => ({
  width: '100%',
  maxWidth: 400,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: 20,
}))

export const Logo = styled('img')(({ theme }) => ({
  width: 150,
  height: 'auto',
  [theme.breakpoints.up('sm')]: {
    width: 170,
  },
}))

export const Card = styled('section')(({ theme }) => ({
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  gap: 18,
  padding: 24,
  borderRadius: 20,
  background: Colors.SURFACE_ON_DARK,
  border: `1px solid ${Colors.BORDER_ON_DARK}`,
  boxShadow: `0 24px 48px ${Colors.SHADOW_CARD}`,
  [theme.breakpoints.up('sm')]: {
    padding: 32,
  },
}))

export const LegalLink = styled('a')(() => ({
  color: 'inherit',
  textDecoration: 'underline',
  textUnderlineOffset: 2,
  '&:hover': {
    color: Colors.WHITE,
  },
}))

export const Copyright = styled(Typography)(() => ({
  color: Colors.TEXT_ON_DARK_MUTED,
  fontSize: '0.8rem',
  textAlign: 'center',
}))
